import BodyType from 'owa-service/lib/contract/BodyType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function getSignature(bodyType: BodyType): string {
    const userOptions = getUserConfiguration().UserOptions;
    return bodyType == 'HTML' ? userOptions.SignatureHtml : userOptions.SignatureText;
}
